import React from 'react';
import { Archive, Loader2 } from 'lucide-react';
import type { LegalFile } from '../../types';

interface ArchiveConfirmationModalProps {
  showArchiveModal: boolean;
  fileToArchive: LegalFile | null;
  archivingFile: boolean;
  language: 'en' | 'ar';
  strings: any;
  onCancel: () => void;
  onConfirm: () => void;
}

const ArchiveConfirmationModal: React.FC<ArchiveConfirmationModalProps> = ({
  showArchiveModal,
  fileToArchive,
  archivingFile,
  language,
  strings,
  onCancel,
  onConfirm
}) => {
  if (!showArchiveModal || !fileToArchive) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center space-x-4 mb-6">
            <div className={`w-12 h-12 ${fileToArchive.isArchived ? 'bg-green-100 dark:bg-green-900/20' : 'bg-orange-100 dark:bg-orange-900/20'} rounded-xl flex items-center justify-center`}>
              <Archive className={`w-6 h-6 ${fileToArchive.isArchived ? 'text-green-600 dark:text-green-400' : 'text-orange-600 dark:text-orange-400'}`} />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-slate-800 dark:text-white">
                {fileToArchive.isArchived ? strings.legalFiles.unarchiveFileTitle : strings.legalFiles.archiveFileTitle}
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400">
                {fileToArchive.title}
              </p>
            </div>
          </div>

          <p className="text-slate-600 dark:text-slate-400 mb-6">
            {fileToArchive.isArchived ? strings.legalFiles.unarchiveFileMessage : strings.legalFiles.archiveFileMessage}
          </p>
          
          <div className="flex items-center justify-end space-x-3">
            <button
              onClick={onCancel}
              disabled={archivingFile}
              className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors duration-200 disabled:opacity-50"
            >
              {strings.legalFiles.cancelArchive}
            </button>
            <button
              onClick={onConfirm}
              disabled={archivingFile}
              className="flex items-center space-x-2 px-4 py-2 bg-primary hover:bg-primary-dark text-white rounded-xl transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {archivingFile ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>{language === 'ar' ? (fileToArchive.isArchived ? 'جاري إلغاء الأرشفة...' : 'جاري الأرشفة...') : (fileToArchive.isArchived ? 'Unarchiving...' : 'Archiving...')}</span>
                </>
              ) : (
                <>
                  <Archive className="w-4 h-4" />
                  <span>{fileToArchive.isArchived ? strings.legalFiles.confirmUnarchive : strings.legalFiles.confirmArchive}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchiveConfirmationModal;
